import { render } from "./TopHeaderV2.vue?vue&type=template&id=37d51857"
import script from "./TopHeaderV2.vue?vue&type=script&lang=js"
export * from "./TopHeaderV2.vue?vue&type=script&lang=js"

import "./TopHeaderV2.vue?vue&type=style&index=0&id=37d51857&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__